import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import { updateProfileApi } from "../../../services/profile.service";

import { useAppDispatch } from "../../../hooks/reduxHooks";

import EditProfileComponent from "../../../components/profile/editProfile";

import { useAppSelector } from "../../../hooks/reduxHooks";
import useGetUserDetails from "../../../hooks/useGetUserDetails";

interface EditProfileContainerInterface {}

const EditProfileContainer: React.FC<EditProfileContainerInterface> = () => {
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const [updatedProfile_pic, setUpdatedProfile_pic] = useState<any>("");

  const [loading, setLoading] = useState(false);

  const [file_list, setFile_list] = useState<any | undefined>();

  const [updatedProfileErrors, setUpdatedProfileErrors] = useState<
    any | undefined
  >();

  const state = useAppSelector((state) => state);

  const { profile_pic } = state?.profile;

  const userInformation = useGetUserDetails();

  const handleImageChange = (image?: any) => {
    setUpdatedProfile_pic(image?.file);
    setFile_list(image?.fileList);
  };

  const onFinish = (val?: any) => {
    let subObj = {
      ...val,
      profile_pic: updatedProfile_pic,
      _method: "PUT",
    };
    setLoading(true);

    dispatch(
      updateProfileApi({
        data: subObj,

        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (response?: any) => {
          navigate("/store");
        },
        failureCallback: (val: any) => {
          setUpdatedProfileErrors(val);
        },
      })
    );
  };

  return (
    <EditProfileComponent
      onFinish={onFinish}
      handleImageChange={handleImageChange}
      file_list={file_list}
      profile_pic={profile_pic}
      updatedProfileErrors={updatedProfileErrors}
      loading={loading}
      userInformation={userInformation}
    />
  );
};

export default EditProfileContainer;
